import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

import { allSharedComponents } from "../../../../../shared";
import { centersActions } from "../../../../../redux/actions";
import { RejectIcon, TickIcon } from "../../../../../assets/images/icon";
import {
  Directions,
  documentStatusConstants,
  fieldLengthConstants,
  globalConstants,
  Regex,
  timezoneConstants,
  translationConstants,
} from "../../../../../constants";
import {
  appendMandatorySignAndTimezoneText,
  convertObjectToFormData,
  serverFormatToDateString,
} from "../../../../../system";
import {
  EditIcon,
  TableViewIcon,
} from "../../../../../assets/images/icon/iconsProvider";

import UpdateNafesModal from "../Modals/UpdateNafesModal";
import RejectModal from "../Modals/RejectModal";

const { ReviewStars, InputFieldWrapper, FileUploader, CustomModal } =
  allSharedComponents;

const GeneralTabSideView = ({ isAdmin, centerId, ...props }) => {
  const methods = useForm();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [certificates, setCertificates] = useState([]);
  const [isCertificateUpdated, setIsCertificateUpdated] = useState(false);
  const [updateNafesModal, setupdateNafesModal] = useState(false);
  const [rejectNafesModal, setRejectNafesModal] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState("");

  const formState = useSelector(
    (state) => state.centersReducer.centerProfileData
  );
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (data) => {
    const dataToSend = {
      ...data,
      centerId: centerId,
      certificate: data.certificate ? data.certificate[0] : null,
    };
    const formData = convertObjectToFormData(dataToSend);
    formData.append("IsCertificateUpdated", isCertificateUpdated);
    dispatch(
      centersActions.updateCenterHeadInstructorDetail(formData, centerId)
    );
  };

  useEffect(() => {
    if (formState) {
      setValue("name", formState.headInstructorInfo?.name);
      setValue("email", formState.headInstructorInfo?.email);
      formState?.headInstructorInfo?.headInstructorCertificate
        ? setCertificates(
            formState?.headInstructorInfo?.headInstructorCertificate
          )
        : setCertificates([]);
    }
    // eslint-disable-next-line
  }, [formState]);

  const handleFileUpload = useCallback(
    (file, key) => {
      setValue(key, file, { shouldValidate: true });
    },
    [setValue]
  );

  return (
    <div>
      <div className="d-none d-md-block">
        <div className="d-flex justify-content-end px-4">
          <ReviewStars value={formState?.overallRating} size={5} />
        </div>

        <div className="d-flex justify-content-end pt-1 px-4 theme-text-color">
          {formState?.noOfReviews} {t(translationConstants.REVIEWS)}
        </div>
      </div>

      <div className="user-profile mt-25">
        <div className="m-l-15 m-r-15">
          {!isAdmin && (
            <>
              <div className="row align-items-center py-1">
                <div className="col-9 col-lg-9 col-md-8 justify-content-center">
                  <h6 className="verify-doc mb-0">
                    {t(translationConstants.NAFES_APPROVAL)}
                  </h6>
                </div>

                <div className="col-3 col-lg-3 col-md-4 d-flex align-items-center justify-content-center">
                  <span className="text-update">
                    {t(translationConstants.Update)}
                  </span>
                  <div className="mx-2">
                    {/* eslint-disable-next-line */}
                    <a
                      className="d-flex align-items-center"
                      onClick={() => setupdateNafesModal((prev) => !prev)}
                    >
                      <EditIcon />
                    </a>
                  </div>
                </div>
              </div>

              {formState?.nafes?.map((nafesItem, index) => (
                <>
                  <div className="row w-100" key={index}>
                    <div className="w-80-percent d-flex align-items-center">
                      <p
                        className={`${
                          direction === Directions.rtl ? "ps-4" : "pe-4"
                        } text-ellipsis`}
                      >
                        {nafesItem?.originalFileName}
                      </p>
                    </div>
                    <div className="w-6-percent m-t-7">
                      {/* eslint-disable-next-line */}
                      <a
                        href={nafesItem?.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <TableViewIcon />
                      </a>
                    </div>
                  </div>

                  <label for="expiryDate" className="form-label mt-2">
                    {appendMandatorySignAndTimezoneText(
                      t(translationConstants.NAFAS_EXPIRY_DATE),
                      t,
                      false
                    )}
                  </label>

                  <div
                    className={direction === Directions.rtl ? "ps-3" : "pe-3"}
                  >
                    <input
                      disabled={true}
                      type="text"
                      id="expiryDate"
                      name="expiryDate"
                      className="form-control profile-field-color mb-3"
                      value={serverFormatToDateString(
                        nafesItem?.expiredOnString,
                        timezoneConstants.dayMonthYearFormat
                      )}
                    />
                  </div>
                </>
              ))}
            </>
          )}

          {isAdmin &&
            formState?.nafes?.map((nafesItem, index) => (
              <>
                <div className="row align-items-center justify-content-between py-1">
                  <div className="col-lg-9 justify-content-center">
                    <h6 className="verify-doc mb-0">
                      {t(translationConstants.NAFES_APPROVAL)}
                    </h6>
                  </div>

                  {nafesItem.documentStatus ===
                    documentStatusConstants.PENDING && (
                    <div className="col-lg-3 d-lg-flex d-block align-items-center justify-content-center">
                      <div className="IconCenter">
                        <img
                          src={TickIcon}
                          alt="Approve Icon"
                          className="pe-1 cursor-pointer"
                          name="approved"
                          height={19}
                          onClick={() => {
                            props.handleNafesApproval(true);
                          }}
                        />
                        <img
                          src={RejectIcon}
                          name="Rejected Icon"
                          height={18}
                          alt=""
                          className="pe-1 cursor-pointer"
                          onClick={() => {
                            setRejectNafesModal(true);
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className="row w-100" key={index}>
                  <div className="w-88-percent d-flex align-items-center">
                    <p
                      className={`${
                        direction === Directions.rtl ? "ps-4" : "pe-4"
                      } text-ellipsis`}
                    >
                      {nafesItem?.originalFileName}
                    </p>
                  </div>

                  <div className="w-6-percent m-t-7">
                    {/* eslint-disable-next-line */}
                    <a href={nafesItem?.link} target="_blank" rel="noreferrer">
                      <TableViewIcon />
                    </a>
                  </div>
                </div>

                <label for="expiryDate" className="form-label mt-2">
                  {appendMandatorySignAndTimezoneText(
                    t(translationConstants.NAFAS_EXPIRY_DATE),
                    t,
                    false
                  )}
                </label>

                <div className="pe-3">
                  <input
                    disabled={true}
                    type="text"
                    id="expiryDate"
                    name="expiryDate"
                    className="form-control profile-field-color mb-3"
                    value={serverFormatToDateString(
                      nafesItem?.expiredOnString,
                      timezoneConstants.dayMonthYearFormat
                    )}
                  />
                </div>
              </>
            ))}
        </div>

        {(formState?.isHeadInstructorShow || isAdmin) &&
          formState?.headInstructorInfo && (
            <div>
              <p className="border-top my-2" />
              <Form
                noValidate
                className="general-side-tab-center"
                onSubmit={handleSubmit(onSubmit)}
              >
                <Row className="m-l-15 m-r-15">
                  <Col md={12} className="my-2">
                    <p className="verify-doc">
                      {t(translationConstants.HEAD_INSTRUCTOR_DETAILS)}
                    </p>
                  </Col>

                  <InputFieldWrapper
                    md={12}
                    label={
                      `${t(translationConstants.HEAD_INSTRUCTOR_NAME)}:` +
                      globalConstants.Mandatory_Character
                    }
                  >
                    <Form.Control
                      type="text"
                      id="name"
                      disabled={!isAdmin || !formState?.isHeadInstructorShow}
                      maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                      placeholder={t(
                        translationConstants.ENTER_HEAD_INSTRUCTOR_NAME
                      )}
                      {...register("name", {
                        required: t(
                          translationConstants.HEAD_INSTRUCTOR_NAME_REQUIRED
                        ),
                        pattern: {
                          value: Regex.titleRegex,
                          message: t(
                            translationConstants.INVALID_HEAD_INSTRUCTOR_NAME
                          ),
                        },
                      })}
                    />
                    {errors?.name && (
                      <p className="errorText">{errors?.name.message}</p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    md={12}
                    label={
                      `${t(translationConstants.HEAD_INSTRUCTOR_EMAIL)}:` +
                      globalConstants.Mandatory_Character
                    }
                  >
                    <Form.Control
                      id="email"
                      type="email"
                      disabled={!isAdmin || !formState?.isHeadInstructorShow}
                      placeholder={globalConstants.EMAIL_PLACEHOLDER}
                      {...register("email", {
                        required: t(translationConstants.emailRequired),
                        pattern: {
                          value: Regex.emailRegex,
                          message: t(translationConstants.invalidEmail),
                        },
                      })}
                    />
                    {errors?.email && (
                      <p className="errorText">{errors?.email.message}</p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    md={12}
                    controlId={"certificate"}
                    label={
                      `${t(
                        translationConstants.UPLOAD_HEAD_INSTRUCTOR_CERTIFICATE
                      )}:` + globalConstants.Mandatory_Character
                    }
                  >
                    {isAdmin && (
                      <div className="filterUploader">
                        <FileUploader
                          sm
                          single
                          defaultValue={certificates}
                          disabled={
                            !isAdmin || !formState?.isHeadInstructorShow
                          }
                          {...register("certificate", {
                            required:
                              certificates.length < 1 &&
                              t(translationConstants.imageRequired),
                          })}
                          onFileUpload={(file) =>
                            handleFileUpload(file, "certificate")
                          }
                          onChangeFlag={setIsCertificateUpdated}
                          isAllowPreview={!formState?.isHeadInstructorShow}
                          setValidationErrorMessage={setValidationErrorMessage}
                          onFileRemove={() => {
                            setCertificates([]);
                          }}
                          isError={
                            errors?.certificate || validationErrorMessage
                          }
                        />
                        {errors?.certificate && !validationErrorMessage && (
                          <p className="errorText">
                            {errors?.certificate.message}
                          </p>
                        )}
                        {validationErrorMessage && (
                          <p className="errorText">{validationErrorMessage}</p>
                        )}
                      </div>
                    )}

                    {formState?.isHeadInstructorShow &&
                      !isAdmin &&
                      formState?.headInstructorInfo?.headInstructorCertificate?.map(
                        (instructorCertificate, index) => (
                          <div className="row w-100" key={index}>
                            <div className="w-88-percent d-flex align-items-center">
                              <p
                                className={`${
                                  direction === Directions.rtl ? "ps-4" : "pe-4"
                                } text-ellipsis`}
                              >
                                {instructorCertificate?.originalFileName}
                              </p>
                            </div>

                            <div className="w-6-percent m-t-7">
                              {/* eslint-disable-next-line */}
                              <a
                                href={instructorCertificate?.link}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <TableViewIcon />
                              </a>
                            </div>
                          </div>
                        )
                      )}
                  </InputFieldWrapper>
                </Row>

                {isAdmin && formState?.isHeadInstructorShow && (
                  <Row className="m-l-15 m-r-15">
                    <Col md={12} className="d-flex justify-content-end">
                      <div className="d-flex">
                        <Button className="profile-button" type="submit">
                          {t(translationConstants.UPDATE_INSTRUCTOR)}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </Form>
            </div>
          )}
      </div>

      <CustomModal
        size="lg"
        scrollable={true}
        show={rejectNafesModal}
        setShow={setRejectNafesModal}
        customClass="view-user-modal"
      >
        <RejectModal
          title={translationConstants.REJECT_NAFES}
          centerId={centerId}
          formState={formState}
          setRejectNafesModal={setRejectNafesModal}
        />
      </CustomModal>

      <CustomModal
        size={"sm"}
        scrollable
        show={updateNafesModal}
        setShow={setupdateNafesModal}
        closeBtnClasses="nafes-modal-close-btn"
      >
        <UpdateNafesModal
          centerId={centerId}
          setupdateNafesModal={setupdateNafesModal}
        />
      </CustomModal>
    </div>
  );
};

export default GeneralTabSideView;
